import React, { Component } from "react";

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';
import { IconButton } from "@material-ui/core";

//material components
import Paper from '@material-ui/core/Paper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//menuItems

class ModalTvHomeApps extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
            homeAppsList: props.homeApps
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }


    //#region  Handlers 
    CleanScheduleModal = () => {

    };
    //#endregion

    //#region  Inner components

    RenderModalContent = () => {

        return (
            <Grid>
                <Paper elevation={3} className="paperModalMultipleDeleteActivities" square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justifyContent='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container>
                            <Grid item justifyContent='center' style={{ width: '100%' }} alignItems='center'>
                                <this.RenderTitleContainer />
                            </Grid>
                            <Grid item justifyContent='center' alignItems='center' style={{ paddingTop: '30px' }}>
                                <this.RenderMessageContainer />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" style={{ paddingTop: '30px' }} justifyContent='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderButtonsContainer = () => {
        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10}>
                    <Grid item container direction='row-reverse'>
                        <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                            <Grid id='close_repair_close_btn' item container className="alingCenter" onClick={() => this.props.OnSaveHandler(this.state.homeAppsList)}>
                                Save
                            </Grid>
                        </Grid>
                        <Grid item container className="VoiceSettingModalButtonYes iconTestStyle alingCenter">
                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                Cancel
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };


    handleDragEnd = (result) => {
        let source = result.source;
        let destination = result.destination;
        let originalData = this.state.homeAppsList;

        if (destination === null)
            return

        const [reordered] = originalData.splice(source.index, 1);
        originalData.splice(destination.index, 0, reordered);

        this.setState({ homeAppsList: originalData });

    }

    RenderMessageContainer = () => {
        const currentData = this.state.homeAppsList;

        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={8} >
                    {/* Home Apps List */}
                    <DragDropContext onDragEnd={this.handleDragEnd}>
                        <Droppable droppableId="HomeApps">
                            {(provided) => (
                                <Grid container className="ModalHomeAppsList" {...provided.droppableProps} ref={provided.innerRef}>
                                    {
                                        currentData && currentData.map((item, index) => {

                                            return (
                                                <Draggable key={item._id} draggableId={item._id} index={index}>
                                                    {(provided, snapshot) => {

                                                        if (snapshot.isDragging) {
                                                            const offset = { x: window.screen.width - 1100, y: 110 } // your fixed container left/top position  modal width 1100 modal height 750
                                                            const x = provided.draggableProps.style.left - (offset.x / 2);
                                                            const y = provided.draggableProps.style.top - offset.y;
                                                            provided.draggableProps.style.left = x;
                                                            provided.draggableProps.style.top = y;

                                                        }

                                                        return (
                                                            <Grid id={`Activity_row_${item._id}`} container alignItems='center' justifyContent='flex-start'
                                                                className="rowEngageStyleList"
                                                                {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}
                                                            >
                                                                <Grid item md={2} lg={2}>
                                                                </Grid>
                                                                <Grid id={`activityRow_thumbnail`} item container xs={12} sm={12} md={4} lg={4} style={{ display: 'flex' }} ><this.ThumbnailImage alt={index} url={item.iconUrl} /></Grid>
                                                                <Grid id={`activityRow_title`} item xs={12} sm={12} md={4} className="rowEngageStyle "
                                                                    style={{ paddingLeft: (window.innerWidth >= 1280 && window.innerWidth < 1600) ? '10px' : '0px' }}>
                                                                    {item.name}
                                                                </Grid>
                                                                <Grid item md={2} lg={2} style={{ textAlign: 'center' }}>
                                                                    <IconButton>
                                                                        <FontAwesomeIcon icon={faEllipsisV} color='#a2a1a2' />
                                                                    </IconButton>
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                    }
                                                    }
                                                </Draggable>
                                            )
                                        })
                                    }
                                    {provided.placeholder}
                                </Grid>
                            )}
                        </Droppable>
                    </DragDropContext>
                </Grid>
            </Grid>
        );
    };

    RenderTitleContainer = () => {
        return (
            <>
                <Grid item container xs={12} direction='row-reverse'>
                    <div className="engage-nav VoiceTitleModal" onClick={() => this.props.OnCancelHandler()}>
                        <img
                            src='https://engage360.s3.amazonaws.com/Icons/circle-xmark.svg'
                            alt='close'
                            className="closeIcon"
                            height="35px"
                        />
                    </div>
                </Grid>
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="MultipleDeleteModalTitle">
                        <Grid>Drag and Drop the tiles in the order that you prefer to show in the TV View</Grid>
                    </Grid>
                </Grid>
            </>
        );
    }
    //#endregion

    //ThumbnailImage
    ThumbnailImage = (
        {
            height = '70px',
            width = '110px',
            alt,
            url
        }
    ) => {
        return (
            <img
                alt={'Thumbnail ' + alt}
                style={{ borderRadius: '10px', margin: '', maxWidth: '100%', objectFit: 'contain' }}
                width={width}
                height={height}
                src={url}
            >
            </img>
        );
    };

    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {

    return {
    }
}


ModalTvHomeApps = reduxForm({
    form: 'ModalTvHomeAppsForm',
    enableReinitialize: true,
})(ModalTvHomeApps);

export default connect(mapStateToProps, {})(ModalTvHomeApps);

